import React, { useEffect, useState } from 'react';
import { IonIcon } from '@ionic/react';
import { arrowBackOutline, chevronForward, closeOutline, person, searchOutline } from 'ionicons/icons';
import { catalogoCabecalho } from '../Utils/catalogoCabecalho';
import './CatalogoCabecalho.css';

type Props = { empresa: any; onSearch: () => void; onProfile?: () => void; onInfo: () => void; onSwitchStore?: () => void };
export default function CatalogoCabecalho({ empresa, onSearch, onProfile, onInfo, onSwitchStore }: Props) {
  const [failed, setFailed] = useState(false);
  const [now, setNow] = useState(Date.now);
  useEffect(() => { setFailed(false); }, [empresa.urlCapaCatalogo]);
  useEffect(() => { const timer = window.setInterval(() => setNow(Date.now()), 60000); return () => window.clearInterval(timer); }, []);
  const info = catalogoCabecalho(empresa, now);
  const hasCover = Boolean(empresa.urlCapaCatalogo && !failed);
  const telefone = String(empresa.empresaTelefone || '').replace(/^55(?=\d{10,11}$)/, '').replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
  return <section className={`catalogo-cabecalho ${hasCover ? 'catalogo-com-capa' : 'catalogo-sem-capa'}`} aria-label="Informações da loja">
    {hasCover && <img className="catalogo-capa" src={empresa.urlCapaCatalogo} alt="" onError={() => setFailed(true)} />}
    <div className="catalogo-cabecalho-acoes">
      {onSwitchStore && <button type="button" className="catalogo-acao catalogo-trocar-loja" aria-label="Voltar para a lista de lojas" onClick={onSwitchStore}><IonIcon icon={arrowBackOutline} /></button>}
      <button type="button" className="catalogo-acao" aria-label="Buscar produtos" onClick={onSearch} disabled={empresa.bloquearAcesso}><IonIcon icon={searchOutline} /></button>
      {onProfile && <button type="button" className="catalogo-acao" aria-label="Meus pedidos" onClick={onProfile}><IonIcon icon={person} /></button>}
    </div>
    <div className="catalogo-loja-painel">
      <button type="button" className="catalogo-loja-identidade" onClick={onInfo} aria-label={`Informações de ${empresa.empresaNome}`}>
        {empresa.urlLogo && <img className="catalogo-loja-logo" src={empresa.urlLogo} alt="Logo da loja" />}
        <span className="catalogo-loja-textos"><strong>{empresa.empresaNome}</strong>{telefone && <span>{telefone}</span>}
          <span className="catalogo-loja-status" style={{ color: info.corHorario }}><span aria-hidden="true">●</span> {info.textoHorario}</span>
        </span><IonIcon icon={chevronForward} />
      </button>
      <div className="catalogo-loja-condicoes">
        <div><span>Entrega</span><strong>{info.textoEntrega}</strong></div>
        <div><span>Taxa de entrega</span><strong>{info.textoTaxaEntrega.startsWith('A partir de ')
          ? <>A partir de <span className="catalogo-taxa-valor">{info.textoTaxaEntrega.slice('A partir de '.length)}</span></>
          : info.textoTaxaEntrega}</strong></div>
        <div><span>Pedido mínimo</span><strong>R$ {info.pedidoMinimo}</strong></div>
      </div>
    </div>
  </section>;
}

type SearchProps = { open: boolean; value: string; inputRef: React.RefObject<HTMLInputElement>; onOpen: () => void; onChange: (text: string) => void; onClose: () => void; children: React.ReactNode };
export function CatalogoNavegacao({ open, value, inputRef, onOpen, onChange, onClose, children }: SearchProps) {
  return <div className="catalogo-navegacao">
    {open ? <div className="catalogo-busca" role="search">
      <div className="catalogo-busca-campo">
        <IonIcon className="catalogo-busca-icone" icon={searchOutline} aria-hidden="true" />
        <input ref={inputRef} type="search" aria-label="Buscar por nome ou descrição" placeholder="Buscar na loja" value={value}
          onChange={e => onChange(e.target.value)} onKeyDown={e => { if (e.key === 'Escape') onClose(); }} />
        <button type="button" className="catalogo-busca-limpar" aria-label={value ? 'Limpar busca' : 'Fechar busca'}
          onClick={() => { if (value) { onChange(''); inputRef.current?.focus(); } else onClose(); }}>
          <IonIcon icon={closeOutline} aria-hidden="true" />
        </button>
      </div>
    </div> : <>
      <button type="button" className="catalogo-acao catalogo-busca-fixa" aria-label="Buscar produtos" onClick={onOpen}><IonIcon icon={searchOutline} /></button>
      <div className="catalogo-navegacao-categorias">{children}</div>
    </>}
  </div>;
}
